import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { nultiSelectStyles } from '../../../../../../../../utils/styles';
import { STATES } from '../../../../../../../../presenters/CashbackPresenter';

const StatesSelect = (props) => {
  const { values, onChange } = props;

  const stateOptions = Object.values(STATES).map((state) => {
    return { key: state, label: state, value: state };
  });

  const defaultStateOptions = stateOptions.filter((option) =>
    values.stateIn.includes(option.value)
  );

  const handleChange = (newValues) => onChange('stateIn', newValues);

  return (
    <Select
      defaultValue={defaultStateOptions}
      isMulti
      id="stateIn"
      options={stateOptions}
      className="basic-multi-select input-underlined"
      classNamePrefix="filter"
      onChange={handleChange}
      styles={nultiSelectStyles}
      required
    />
  );
};

export default StatesSelect;

StatesSelect.propTypes = {
  values: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
};
